import React from "react";
import { KPIS } from "../lib/site-data";

export const KPIBand = () => (
  <section
    id="kpis"
    data-testid="kpi-band"
    className="relative bg-brand-green-100 border-y border-[color:var(--brand-green-200)]"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 md:gap-6">
        {KPIS.map((k, i) => (
          <div
            key={k.label}
            data-testid={`kpi-${i}`}
            className="text-center md:text-left border-l-0 md:border-l md:first:border-l-0 md:border-[color:var(--brand-green-300)] md:pl-5"
          >
            <div className="font-display text-4xl md:text-5xl font-bold text-navy leading-none">
              {k.value}
            </div>
            <div className="mt-2 text-sm md:text-[13px] text-[color:var(--brand-green-700)] uppercase tracking-[0.14em] font-semibold">
              {k.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
